<template>
  <div class='interactives-will-template'>
    <button class="back-button" @click="$emit('back')">« Back</button>
    <div class="will-output-body">
      <p class="will-disclaimer"><em>This document is <strong>not legally binding or enforceable</strong>.</em></p>
      <p>
        I, {{ templateData.userName.value }} of {{ templateData.userResidence.value }}, establish this as my digital will, laying out my preferences for the future use of my online accounts.
      </p>
      <p>
        I appoint {{ templateData.execName.value }} of {{ templateData.execResidence.value }} as the sole executor of this will.
      </p>
      <p>
        Where appropriate and necessary, passwords and other login credentials will be provided to my executor via separate documentation.
      </p>
      <p>
        I give my executor the following duties and responsibilities:
      </p>
      <div v-show="formData[2].value">
          <h3>
              Web browsing history
          </h3>
          <p>
              Delete the entire browsing history from all browsers on my computer.
          </p>
      </div>
      <div v-show="selected('Email')">
        <h3>
          Email
        </h3>
        <p>
          I employ {{ templateData.email[0].value }}. Within 30 days of my death, I request that my executor access that account using the login credentials provided via supplementary documentation. They should then:
          <ul>
            <li v-for="item in templateData.email[1].value">{{ item }}</li>
          </ul>
        </p>
      </div>
      <div v-show="selected('Facebook')">
          <h3>
              Facebook
          </h3>
          <p>
              I maintain a Facebook account under {{ templateData.facebook[0].value }}. Within 30 days of my death, I request that my executor {{ templateData.facebook[1].value }}.
          </p>
      </div>
        <div v-show="selected('Twitter')">
          <h3>
              Twitter
          </h3>
          <p>
            I maintain a Twitter account under {{ templateData.twitter[0].value }}<span v-show="templateData.twitter[0].value == 'the handle'"> @{{ templateData.twitter[1].value }}</span>. Within 30 days of my death, I request that my executor {{ templateData.twitter[2].value }}.
          </p>
        </div>
        <div v-show="selected('Amazon')">
            <h3>
              Amazon
            </h3>
            <p>
              I maintain an Amazon account under {{ templateData.amazon[0].value }}. Where allowed, I grant and transfer ongoing ownership of all e-books, digital movies, and music associated with that account to {{ templateData.amazon[1].value }}. In addition, I request that my executor access my account and:
              <ul>
                <li v-for="item in templateData.amazon[2].value">{{ item }}</li>
              </ul>
            </p>
        </div>
        <div v-show="selected('iTunes')">
          <h3>
              iTunes
          </h3>
          <p>
            I maintain an iTunes account under {{ templateData.itunes[0].value }}. Where allowed, I grant and transfer ongoing ownership of all digital content associated with that account to {{ templateData.itunes[1].value }}.
            </p>
        </div>
        <div v-for="(service, index) in formData[1].value">
            <h3>
                {{ service }}
            </h3>
            <p>
              I maintain an account with {{ service }} under the login {{ templateData.additional[service][0].value }}. I request that my executor do the following with that account:
              <ul>
                <li v-for="(item, index) in templateData.additional[service][1].value">{{ item === 'transfer' ? `Transfer ownership of all associated digital media to ${templateData.additional[service][2].value}.` : item }}</li>
              </ul>
              In addition, {{ templateData.additional[service][3].value }}
            </p>
        </div>
        <p><strong>I have signed my name</strong> on this the __________________________ (today’s date), declaring this is my digital will in the presence of the witnesses below.</p>
        <p>__________________________</p>
        <p>__________________________</p>
        <p>__________________________</p>
    </div>
    <div class="cont-btn-c"><button class="print-button" @click="print">Print</button></div>
  </div>
</template>

<script>
import * as $ from 'jquery'

export default {
  name: 'interactives-will-output',
  props: ['formData', 'templateData'],
  methods: {
    selected (string) { return $.inArray(string, this.formData[0].value) > -1 },
    print () {
      const content = $('.will-output-body').html()
      const mywindow = window.open('', 'Print', 'height=600,width=800')

      mywindow.document.write('<html><head><title>Digital Will</title>')
      mywindow.document.write('</head><body >')
      mywindow.document.write(content)
      mywindow.document.write('</body></html>')

      mywindow.document.close()
      mywindow.focus()
      mywindow.print()
      mywindow.close()
      return true
    }
  }
}
</script>

<style lang="scss">
.interactives-will-output {

}
</style>



// WEBPACK FOOTER //
// src/components/WillOutput.vue